import $ from 'jquery';
import 'remodal';

$('[data-remodal-id]').each(function (index, element) {
  const $element = $(element);
  const instance = $element.remodal();
  if ($element.attr('data-remodal-auto') !== undefined) {
    instance.open();
  }
});
